namespace Matrix.Data {
    export class SecurityMatchRulesetRulesColumns {
        static columnsKey = 'Data.SecurityMatchRulesetRules';
    }
}
